// Tailwind bg-* class (as stored on a role) → hex, so a role's color can be
// printed as a thin stripe or dot with print-color-adjust instead of a solid
// fill. Mirrors the palette in helpers.getLockedColorLookup.
export const ROLE_COLOR_HEX = {
  "bg-violet-600": "#7c3aed",
  "bg-sky-700": "#0369a1",
  "bg-cyan-600": "#0891b2",
  "bg-emerald-600": "#059669",
  "bg-lime-600": "#65a30d",
  "bg-amber-500": "#f59e0b",
  "bg-orange-600": "#ea580c",
  "bg-red-600": "#dc2626",
  "bg-pink-600": "#db2777",
};

export const DEFAULT_ROLE_COLOR = "#475569";

export function roleColorHex(roleId, roleNames) {
  const cls = roleNames?.find((r) => r.id === roleId)?.color;
  return ROLE_COLOR_HEX[cls] || DEFAULT_ROLE_COLOR;
}

// Basic mode shifts come from the schedule serializer (`role_id`); the
// multi-location endpoint dumps raw model fields (`role_id_id`).
export function shiftRoleId(shift) {
  return shift?.role_id ?? shift?.role_id_id ?? null;
}
